// FundraisingCard.options.js
import { computed } from 'vue'
import { GeneralSearchLayoutEnum } from '../GeneralSearch/subcomponents/GeneralSearchLayoutEnums'
export default {
  name: 'FundraisingCard',
  props: {
    result: {
      type: Object,
      required: true,
      default: () => ({
        imgUrl: '',
        name: '',
        target: 0,
        current: 0,
        hideTarget: false,
        url: ''
      })
    },

    displayProperties: {
      type: Object,
      required: false,
      default: null
    }
  },

  setup(props) {
    const target = computed(() =>
      new Intl.NumberFormat('da-DK', {
        style: 'currency',
        currency: 'DKK',
        maximumFractionDigits: 0
      }).format(props.result.target)
    )

    const current = computed(() =>
      new Intl.NumberFormat('da-DK', {
        style: 'currency',
        currency: 'DKK',
        maximumFractionDigits: 0
      }).format(props.result.current)
    )

    const progress = computed(() => {
      const rawProgress = (props.result.current * 100) / props.result.target
      return Math.min(rawProgress, 100)
    })

    const isMindegaveLayout = computed(() => {
      return props.displayProperties?.layout === GeneralSearchLayoutEnum.Mindegave
    })

    return { target, current, progress, isMindegaveLayout }
  }
}